import { render, staticRenderFns } from "./pcHeader.vue?vue&type=template&id=970ba892&scoped=true&"
import script from "./pcHeader.vue?vue&type=script&lang=js&"
export * from "./pcHeader.vue?vue&type=script&lang=js&"
import style0 from "./pcHeader.vue?vue&type=style&index=0&id=970ba892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970ba892",
  null
  
)

export default component.exports